"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageType = void 0;
/**
 * Different type of damage our system supports.
 *
 * *Swagger Schema Reference :* `ReservedDamagesNames`
 */
var DamageType;
(function (DamageType) {
    DamageType["BODY_CRACK"] = "body_crack";
    DamageType["BROKEN_GLASS"] = "broken_glass";
    DamageType["BROKEN_LIGHT"] = "broken_light";
    DamageType["DENT"] = "dent";
    DamageType["DIRT"] = "dirt";
    DamageType["HUBCAP_SCRATCH"] = "hubcap_scratch";
    DamageType["MISSHAPE"] = "misshape";
    DamageType["MISSING_HUBCAP"] = "missing_hubcap";
    DamageType["MISSING_PIECE"] = "missing_piece";
    DamageType["PAINT_PEELING"] = "paint_peeling";
    DamageType["RUSTINESS"] = "rustiness";
    DamageType["SCATTERED_SCRATCHES"] = "scattered_scratches";
    DamageType["SCRATCH"] = "scratch";
    DamageType["SMASH"] = "smash";
    DamageType["LIGHT_REFLECTION"] = "light_reflection";
    DamageType["SHADOW"] = "shadow";
    DamageType["CAR_CURVE"] = "car_curve";
})(DamageType = exports.DamageType || (exports.DamageType = {}));
//# sourceMappingURL=entityTypes.js.map